module.exports = __webpack_public_path__ + "img/folder.7dd583f1.png";